export default __webpack_public_path__ + "static/media/logoAVStarLight.f85c474d.png";